import { Component, useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import Lenis from "lenis";

import Nav from "./components/Nav";
import Hero from "./components/Hero";
import Marquee from "./components/Marquee";
import Challenge from "./components/Challenge";
import Programme from "./components/Programme";
import WhyWeave from "./components/WhyWeave";
import Mentors from "./components/Mentors";
import Tuition from "./components/Tuition";
import Faq from "./components/Faq";
import { FinalCta, WaitlistModal } from "./components/Waitlist";
import Footer from "./components/Footer";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-paper p-8 text-center">
          <p className="text-lg text-body2">Something wove itself into a knot. Please refresh the page.</p>
        </div>
      );
    }
    return this.props.children;
  }
}

function App() {
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.1, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = undefined;
    };
  }, []);

  useEffect(() => {
    if (!window.__lenis) return;
    if (modalOpen) window.__lenis.stop();
    else window.__lenis.start();
  }, [modalOpen]);

  const openWaitlist = () => setModalOpen(true);

  return (
    <ErrorBoundary>
      <BrowserRouter>
        <div className="relative min-h-screen overflow-x-clip bg-paper font-sans text-ink">
          <div className="grain" aria-hidden="true" />
          <Nav onJoin={openWaitlist} />
          <main>
            <Hero onJoin={openWaitlist} />
            <Marquee />
            <Challenge />
            <Programme />
            <WhyWeave />
            <Mentors />
            <Tuition />
            <Faq />
            <FinalCta />
          </main>
          <Footer onJoin={openWaitlist} />
          <AnimatePresence>
            {modalOpen && <WaitlistModal onClose={() => setModalOpen(false)} />}
          </AnimatePresence>
        </div>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
